/* istanbul ignore file */
import { LabelValuePairs, LabelValuePair } from "../types";

export const enum2options = (e: object): LabelValuePairs =>
  Object.values(e).map((value): LabelValuePair => ({ label: value || "Selecteer een optie", value }));
